<template>
  <div class="login-page">
    <div class="login-bg">
      <!-- Elementos gráficos do fundo ficam aqui -->
    </div>
    <div class="login-form-container">
      <div class="logo-container">
        <img class="login-logo" src="../assets/images/logo.png" alt="Logo" />
      </div>
      
      <div class="login-box">
        <h4 class="login-title">Bem-vindo ao Portal do Cliente</h4>
        
        <div v-show="forgot_password" class="login-inner-container">
          <p class="text-center">
            Insira o seu email para iniciar o processo de alteração de senha
          </p>
          <div class="form-group">
            <label>E-mail</label>
            <input type="text" v-model="email" class="form-control" />
          </div>
        </div>
        
        <div v-show="!forgot_password" class="login-inner-container">
          <div class="form-group">
            <label>E-mail</label>
            <input type="text" v-model="email" v-on:keyup.enter="login" class="form-control" />
          </div>
          
          <div class="form-group">
            <label>Senha</label>
            <div v-if="isEdge">
              <input type="password" v-model="password" v-on:keyup.enter="login" class="form-control" />
            </div>
            <div v-else class="password-container">
              <input :type="showPassword ? 'text' : 'password'" v-model="password" v-on:keyup.enter="login" class="form-control" />
              <button type="button" class="toggle-password" @click="togglePasswordVisibility">
                <font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
              </button>
            </div>
          </div>
        </div>
        
        <button v-show="!forgot_password" @click="login" class="login-button">
          Acessar o Portal
        </button>
        <button v-show="forgot_password" @click="forgot" class="login-button">
          Enviar
        </button>
        
        <div class="login-links">
          <div class="forgot-link clickable" @click="forgot_password = !forgot_password">
            {{ forgot_password_text }}
          </div>
          
          <div class="register-link">
            <router-link v-show="!forgot_password" to="/register" class="clickable">
              Ainda não tem cadastro? Solicite seu acesso!
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      forgot_password: false,
      isEdge: false,
    };
  },
  computed: {
    forgot_password_text() {
      return this.forgot_password ? "Fazer login" : "Esqueci minha senha";
    },
  },
  mounted() {
    this.showPassword = false;
    this.detectEdge();
  },
  methods: {
    detectEdge() {
      const userAgent = navigator.userAgent || navigator.userAgentData;
      this.isEdge = /Edg\//.test(userAgent);
    },
    togglePasswordVisibility() {
      if (this.password.length === 0) {
        this.showPassword = false;
      } else {
        this.showPassword = !this.showPassword;
      }
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          email: self.email,
          password: self.password,
        })
        .then((response) => {
          self.$store.dispatch("setToken", response.data);
        })
        .catch((error) => {
          this.$toast.error("Credenciais Inválidas");
        });
    },
    forgot() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.email,
        })
        .then((response) => {
          this.$toast.success(
            "Sucesso, enviamos um email para " +
            self.email +
            ". Por favor, confira a sua caixa de entrada! "
          );
        })
        .catch((error) => {
          this.$toast.error("Falha ao enviar email para " + self.email + ".");
        });
    },
  },
};
</script>

<style scoped>

#app{
  width: 100% !important;
  min-height: 100vh !important;
}

div#app{
  width: 100% !important;
  min-height: 100vh !important;
}

body{
  width: 100% !important;
  min-height: 100vh !important;
}

.login-page {
  display: flex;
  height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.login-bg {
  flex: 1;
  background: url('../assets/images/bg-login.jpg') center/cover no-repeat;
  position: relative;
  overflow: hidden;
}

.login-form-container {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 40px;
}

.logo-container {
  margin-bottom: 40px;
  text-align: center;
}

.login-logo {
  max-width: 250px;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
}

.login-title {
  text-align: center;
  margin-bottom: 25px;
  font-weight: 600;
  color: #333;
}

.login-inner-container {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #f5f5f5;
  font-size: 15px;
}

.password-container {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #777;
  cursor: pointer;
}

.login-button {
  width: 100%;
  padding: 12px;
  background-color: #006638;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.login-button:hover {
  background-color: #005530;
}

.login-links {
  margin-top: 25px;
  text-align: center;
}

.forgot-link {
  color: #0066cc;
  margin-bottom: 15px;
  font-size: 14px;
}

.register-link {
  margin-top: 10px;
  font-size: 14px;
  color: #555;
}

.clickable {
  cursor: pointer;
}

@media (max-width: 1024px) {
  .login-form-container {
    width: 50%;
  }
}

@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
  }
  
  .login-bg {
    display: none;
  }
  
  .login-form-container {
    width: 100%;
    padding: 20px;
  }
  
  .login-box {
    box-shadow: none;
    padding: 20px 0;
  }
}
</style>
